var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.196 7c5.069 0 9.196 4.128 9.196 9.196 0 5.069-4.127 9.196-9.196 9.196-5.068 0-9.196-4.127-9.196-9.196C7 11.128 11.128 7 16.196 7z",
    fill: "#B5393F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.03 13.57a2.765 2.765 0 00-.649-1.37h1.823a.599.599 0 00.602-.596.597.597 0 00-.596-.596h-6.028a.597.597 0 00-.595.596c0 .328.268.596.595.596h1.728a2.013 2.013 0 011.9 1.37h-3.628a.597.597 0 00-.595.595c0 .328.268.596.595.596h3.628c-.096.31-.268.595-.495.828-.369.38-.875.595-1.405.601h-1.728a.577.577 0 00-.41 1l4.312 4.075c.238.226.619.214.84-.03a.573.573 0 00-.013-.81c-.005-.006-.011-.006-.011-.012l-3.223-3.032h.227a3.2 3.2 0 002.251-.947 3.07 3.07 0 00.876-1.673h1.179a.597.597 0 00.596-.596.597.597 0 00-.596-.595h-1.18z",
    fill: "#FFF"
  }))));
}
export default SvgPricing;